import React, { useRef, useState } from "react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import MoodIcon from "@mui/icons-material/Mood";
import SendIcon from "@mui/icons-material/Send";
import Message from "../../../components/Message/Message";
import { Button, Popover, Box } from "@mui/material";
import { conversationAtom,chosenUserAtom, conversationsCacheAtom } from "../atoms/ChatAtom";
import { useAtom, useAtomValue } from "jotai";
import { useEffect } from "react";
import { usersAtom } from "../atoms/ChatAtom";
import axios from "axios";
import { url } from "../../../url";
import { socket } from "../../../socket/socket";

socket.connect();
const ChatView = () => {
  const [updater,setUpdater] = useState(false);
  const [input,setInput] = useState("");
  const [conversation,setConversation] = useAtom(conversationAtom); 
  const [chosenUser,setChosenUser] = useAtom(chosenUserAtom);
  const [conversationsCache, setConversationsCache] = useAtom(conversationsCacheAtom);
  const listRef = useRef<null | HTMLDivElement>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [emojiAnchor, setEmojiAnchor] = useState<null | HTMLElement>(null);

  useEffect(()=>{
    if (conversation._id) {
      scrollToBottom();
      socket.emit("join",conversation._id);
      return ()=>{
        socket.off("join");
      }
    }
  },[conversation._id]);
   
  useEffect(()=>{
    socket.on("message",(data)=>{
        setConversation((prevState: any)=>{
          const updatedConversation = {
            ...prevState,
            messages: [...prevState.messages,{
              conversationId: conversation._id,
              senderId: chosenUser._id, 
              message: data.text,
              date: new Date().toISOString(),
            }]
          };
          
          // Update cache
          setConversationsCache(prev => ({
            ...prev,
            [chosenUser._id]: updatedConversation
          }));
          
          return updatedConversation;
        });
        setUpdater(prevState => !prevState);
        scrollToBottom();
    });

    return () => {
      socket.off("message");
    };
  },[chosenUser._id, conversation._id ]);

  const scrollToBottom = ()=>{
    listRef.current?.scrollIntoView({behavior: 'smooth'});
  };

  const onChangeInput =(event :  React.ChangeEvent<HTMLInputElement>)=>{
    setInput(event.target.value);
  };

  const sendMessage = async()=>{
    if(chosenUser?._id && input.length != 0){
      socket.emit("chat",{
        room: conversation._id,
        user: chosenUser._id,
        text: input
      });
      const response = await axios.post(url + `/chat/sendMessage`,{
        id: chosenUser._id,
        message: input
      },{
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+ localStorage.getItem("token")
        }
      });
      const tempConversation = conversation;
      tempConversation.messages.push(response.data.message);
      setConversation(tempConversation);
      
      // Update cache
      setConversationsCache(prev => ({
        ...prev,
        [chosenUser._id]: tempConversation
      }));
      
      setInput("")
      scrollToBottom();
    }
  };

  const handleAttachClick = () => {
    fileInputRef.current?.click();
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setConversation((prev: any) => ({
        ...prev,
        messages: [
          ...prev.messages,
          {
            _id: Math.random().toString(36),
            senderId: chosenUser._id,
            message: `📎 ${file.name}`,
            date: new Date().toISOString(),
          },
        ],
      }));
      setUpdater((u) => !u);
    }
  };
  const handleEmojiClick = (event: React.MouseEvent<any>) => {
    setEmojiAnchor(event.currentTarget);
  };
  const handleEmojiSelect = (emoji: string) => {
    setInput((prev) => prev + emoji);
    setEmojiAnchor(null);
  };
  const handleEmojiClose = () => {
    setEmojiAnchor(null);
  };

  if(!conversation.messages) return null;

  return (
    <div className="conversations__container__chat">
      <div className="conversations__container__chat__box"  style={{overflowY: 'scroll',height: '100%'}}>
        {
          conversation.messages?.length ?
          conversation.messages?.map((message: any)=>{
            return(
              <Message key={message?._id}  myMessage={message.senderId !== chosenUser._id} content={message.message} time={message.date}/>
            )
          }) : "No messages"
        }
        <div ref={listRef}/>
      </div>

      <div className="conversations__container__chat__typeBox">
        <div className="conversations__container__chat__typeBox__type">
          <AttachFileIcon className="conversations__container__chat__typeBox__type__file" onClick={handleAttachClick} style={{ cursor: 'pointer' }} />
          <input type="file" style={{ display: 'none' }} ref={fileInputRef} onChange={handleFileChange} />
          <input
            type="text"
            placeholder="Type your message here..."
            className="conversations__container__chat__typeBox__type__input"
            onChange={onChangeInput}
            value={input}
          />
          <MoodIcon className="conversations__container__chat__typeBox__type__modeIcon" onClick={handleEmojiClick} style={{ cursor: 'pointer' }} />
          <Popover
            open={Boolean(emojiAnchor)}
            anchorEl={emojiAnchor}
            onClose={handleEmojiClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          >
            <Box sx={{ display: 'flex', gap: 1, p: 1 }}>
              {['😀','😂','😍','👍','🙏','🎉','😎','😢','🔥','🚀'].map((emoji) => (
                <span key={emoji} style={{ fontSize: 24, cursor: 'pointer' }} onClick={() => handleEmojiSelect(emoji)}>{emoji}</span>
              ))}
            </Box>
          </Popover>
        </div>
        <Button
          variant="contained"
          size="small"
          className="conversations__container__chat__typeBox__sendButton"
          onClick={sendMessage}
        >
          <SendIcon className="conversations__container__chat__typeBox__sendButton__sendIcon" />
        </Button>
      </div>
      {updater}
    </div>
  );
};

export default ChatView;
